module.exports = __webpack_public_path__ + "img/preview-on-icon.4ec17777.svg";